<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-end">
            <div class="px-1">
                <app-form-text-input 
                    placeholder="Título"
                    v-model="filters.name"
                />
            </div>

            <div class="px-1">
                <b-button-group>
                    <b-button :variant="filters.date === -1?'success':'secondary'" @click="setDate('vencidas')" >Vencidas</b-button>
                    <b-button :variant="filters.date === 1?'success':'secondary'" @click="setDate('hoy')" >Hoy</b-button>
                    <b-button :variant="filters.date === 2?'success':'secondary'" @click="setDate('mañana')">Mañana</b-button>
                    <b-button :variant="filters.date === 3?'success':'secondary'" @click="setDate('proxima semana')">Próximos 8 días</b-button>
                </b-button-group>
            </div>
            <div class="px-1">
                <b-button variant="primary" @click="onFilter"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-1">
                <b-button variant="secondary" @click="cleanFilter"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            filters: {
                name: '',
                date: ''
            }
        }
    },

    methods:{
        onFilter(){
            this.$emit('filter', this.filters);
        },
        cleanFilter(){
            Object.keys(this.filters).map(key => (this.filters[key] = ''));
            this.$emit('clean', this.filters);
        },
        setDate(option){
            if(option === 'hoy'){
                this.filters.date = 1;
            }else if(option === 'mañana'){
                this.filters.date = 2;
            } else if(option === 'proxima semana'){
                this.filters.date = 3;
            } else if(option === 'vencidas'){
                this.filters.date = -1;
            }
            this.onFilter();
        }
    },

    created(){
        this.$bus.$on('filters.clean', this.cleanFilter);  
    }
}
</script>
